<template>
  <div>
    <a
      :class="{
        'mobile-banner': true,
        'd-none': $router.currentRoute.meta.officeAdmin
      }"
      href="http://onelink.to/wtr52f"
    >
      <div class="d-flex align-items-center">
        <span class="mobile-text">
          For a better experience, get our new mobile app
        </span>
      </div>

      <div class="download-button mx-2"><span>Download</span></div>
    </a>

    <nav>
      <ul
        class="nav navbar justify-content-between align-items-center bg-white"
      >
        <li class="nav-item pull-sm-left">
          <router-link to="/restaurants" id="logo" v-if="!adminMenuButtonHide">
            <img
              src="../assets/img/logo-uncatering.png"
              alt="Uncatering"
              text-align="center"
              data-retina="true"
              class="logo d-sm-block"
            />
          </router-link>

          <font-awesome-icon
            icon="bars"
            class="nav--icon"
            size="2x"
            @click="showAdminMenu()"
            v-else
          />
        </li>
        <li class="text-white dropdown pull-sm-right navMenu">
          <a
            class="pull-left dropdown-toggle font-weight-bold text-bleck "
            href="javascript:void(0);"
            id="navbarDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <div class="navMenu--container">
              <span class="name text-capitalize">
                {{
                  `${employee.first_name ? employee.first_name : ""} ${
                    employee.last_name ? employee.last_name : ""
                  }`
                }}
              </span>
              <span class="office-name">
                {{
                  currentOrganization &&
                    currentOrganization.attributes.organization_name
                }}
              </span>
            </div>
            <font-awesome-icon class="caret" icon="caret-down" size="1x" />
          </a>

          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="navbarDropdown"
          >
            <div
              v-if="
                currentOrganization &&
                  !currentOrganization.attributes.soft_deleted &&
                  currentEmp &&
                  (currentEmp.role == 'admin' || currentEmp.team_admin)
              "
            >
              <router-link
                to="/admin"
                class="dropdown-item drop-down-item admin-padding"
              >
                Admin
              </router-link>
              <hr />
            </div>

            <div
              v-if="employee && filteredEmployees.length >= 1"
              class="org-container"
            >
              <button
                v-for="(emp, index) in filteredEmployees"
                :key="emp.id"
                :class="{
                  'dropdown-item office-button': true,
                  'office-button-pad': index > 0
                }"
                @click="setOrganization(emp)"
              >
                <span class="text-left">{{
                  emp && emp.attributes.organization_name
                }}</span>
              </button>
              <hr />
            </div>

            <router-link
              v-if="
                currentOrganization &&
                  !currentOrganization.attributes.soft_deleted
              "
              to="/restaurants"
              class="dropdown-item drop-down-item"
            >
              Restaurants
            </router-link>

            <router-link to="/orders" class="dropdown-item drop-down-item">
              Orders
            </router-link>

            <router-link
              v-if="
                currentOrganization &&
                  !currentOrganization.attributes.soft_deleted
              "
              to="/profile"
              class="dropdown-item drop-down-item"
            >
              Profile
            </router-link>

            <router-link to="/faq" class="dropdown-item drop-down-item">
              FAQs
            </router-link>

            <div
              v-on:click.prevent="showReferralModal"
              class="dropdown-item drop-down-item refer-text"
            >
              Refer & Earn $100
            </div>

            <div
              v-on:click.prevent="logOut"
              class="dropdown-item drop-down-item"
            >
              Logout
            </div>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { logOut, clearPKToken } from "../utils/api";
import { mapState, mapGetters } from "vuex";
import { errorHandler } from "@/utils/errorHandler";

export default {
  name: "LoggedInHeader",
  data() {
    return {
      desktopText: "Don't forget to PLACE ORDER to complete checkout.",
      mobileText:
        "Don't forget to tap YOUR CART and PLACE ORDER to complete checkout.",
      descText:
        "Just a reminder that you still have items in your cart. Don't forget to complete the checkout process. If you need to speak with us, you can use the live-chat icon at the bottom left of the page, or email us at help@hungerhub.com.",
      contestOffices: ["Miguel's staging test office", "70RE", "ZYN2", "EXP"]
    };
  },
  computed: {
    ...mapState([
      "employee",
      "cart",
      "currentEmp",
      "currentOrganization",
      "adminMenuButtonHide"
    ]),
    filteredEmployees() {
      let filtered = this.employee.employees.filter(
        emp =>
          emp?.attributes?.id !== this?.currentOrganization?.attributes?.id &&
          emp?.attributes?.organization_type == "Location" &&
          emp?.attributes?.organization_active &&
          !emp?.attributes?.soft_deleted
      );

      return filtered.length >= 1 ? filtered : [];
    }
  },
  mounted() {
    let self = this;

    document.addEventListener("visibilitychange", function() {
      let isOfficeAdmin = self.$router.currentRoute.meta.officeAdmin;

      if (
        self.cart.items.length > 0 &&
        window.innerWidth > 768 &&
        !isOfficeAdmin
      ) {
        self.$swal({
          title: self.desktopText,
          text: self.descText,
          confirmButtonText: "OK"
        });
      }

      if (
        self.cart.items.length > 0 &&
        window.innerWidth <= 768 &&
        !isOfficeAdmin
      ) {
        self.$swal({
          title: self.mobileText,
          text: self.descText,
          confirmButtonText: "OK"
        });
      }
    });
    // Refactor this to use CSS if possible
    window.addEventListener("resize", function() {
      // let pathname = self.$router.currentRoute.name;
      let isOfficeAdmin = self.$router.currentRoute.meta.officeAdmin;
      if (isOfficeAdmin && window.innerWidth < 920) {
        self.$store.commit("HIDE_ADMIN_MENU");
        self.$store.commit("SHOW_ADMIN_BUTTON_MENU");
      } else {
        self.$store.commit("SHOW_ADMIN_MENU");
        self.$store.commit("RESET_ADMIN_BUTTON_MENU");
      }
    });
  },
  methods: {
    setOrganization(org) {
      this.$store.commit("SET_ORGANIZATION", org);
      this.$store.dispatch("FETCH_LOCATION");
      this.$store.commit("UPDATE_TIP", "0");
      this.$store.commit("UPDATE_TIP_OFFICE_ADMIN", "0");

      if (
        (this.$router.currentRoute.meta.officeAdmin &&
          (org.attributes.role !== "admin" ||
            org.attributes.administered_teams.length == 0)) ||
        this.$router.currentRoute.name == "Restaurants"
      ) {
        this.$router.push("/restaurants").catch(err => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location" ||
                "Navigation cancelled from"
            )
          ) {
            errorHandler(err);
          }
        });
      }

      setTimeout(() => location.reload(), 1500);
    },
    showReferralModal() {
      document.body.classList.toggle("noscroll");
      this.$modal.show("referral-modal");
    },
    logOut() {
      const isAdminEmployeeLogin = localStorage.getItem("pk");
      if (isAdminEmployeeLogin) {
        if (
          confirm(
            "Would you like to log out from the user you have logged in as an admin? Your previous window won't be affected."
          )
        ) {
          clearPKToken();
          location.reload();
        }
      } else {
        logOut(this);
      }
    },
    checkInactive() {
      let timeoutInMiliseconds = 5000;
      let timeoutId = window.setTimeout(doInactive, timeoutInMiliseconds);
      let userInactive = false;
      let self = this;

      document.addEventListener("mousemove", resetTimer, false);
      document.addEventListener("mousedown", resetTimer, false);
      document.addEventListener("keypress", resetTimer, false);
      document.addEventListener("touchmove", resetTimer, false);

      function doInactive() {
        let isOfficeAdmin = self.$router.currentRoute.meta.officeAdmin;

        if (self.cart.items.length > 0) {
          userInactive = true;
          window.clearTimeout(timeoutId);
          if (window.innerWidth > 768 && !isOfficeAdmin) {
            self
              .$swal({
                title: self.desktopText,
                text: self.descText,
                confirmButtonText: "OK"
              })
              .then(() => {
                userInactive = false;
                resetTimer();
              })
              .catch(err => {
                errorHandler(err);
              });
          }
          if (window.innerWidth <= 768 && !isOfficeAdmin) {
            self
              .$swal({
                title: self.mobileText,
                text: self.descText,
                confirmButtonText: "OK"
              })
              .then(() => {
                userInactive = false;
                resetTimer();
              })
              .catch(err => {
                errorHandler(err);
              });
          }
        }
      }

      function resetTimer() {
        if (!userInactive) {
          window.clearTimeout(timeoutId);
          timeoutId = window.setTimeout(doInactive, timeoutInMiliseconds);
        }
      }
    },
    showAdminMenu() {
      this.$store.commit("TOGGLE_ADMIN_MENU");
    }
  }
};
</script>

<style>
.refer-text {
  color: #cc3399;
}

.org-container {
  max-height: 150px;
  overflow: auto;
}

#logo img {
  margin-right: 0px;
  padding-top: 8px;
}

.dropdown-toggle::after {
  display: none;
}

.ml-m {
  margin-left: 95px;
}

.drop-down-item {
  padding: 0.01rem 0.8rem !important;
  padding-bottom: 12px !important;
}

.office-button {
  padding: 0.01rem 0.8rem !important;
}

.office-button-pad {
  padding-top: 7px !important;
}

.admin-padding {
  padding-top: 4px !important;
  padding-bottom: 0 !important;
}

.drop-down-item:hover {
  background-color: white !important ;
  color: #373980 !important;
  cursor: pointer;
}

.drop-down-item.router-link-active {
  color: #cc3399 !important;
}

.active-location {
  color: #cc3399 !important;
}

.name {
  color: black;
  text-align: left !important;
  font-weight: 500 !important;
}

.office-name {
  color: #707070 !important;
  text-align: left !important;
  font-weight: 400 !important;
  font-size: 12px !important;
}

.user-name {
  color: #a6d2d4 !important;
}

.navMenu {
  display: flex;
  flex-direction: column;
  color: black;
  justify-content: flex-end;
  align-items: flex-end;
}

.navMenu span {
  color: black;
  display: block;
  text-align: right;
  font-size: 12px;
}

.navMenu a {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.navMenu--container {
  margin-right: 15px;
}

.navMenu img {
  display: block;
}

.hide-mobile {
  display: block !important;
}

.hide-desktop {
  display: none !important;
}

.mobile-bold {
  font-weight: bold;
}

.caret {
  color: black;
}

.logo {
  width: 125px;
}

.navbar {
  padding: 0.8rem 1rem;
  z-index: 999;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}

.mobile-banner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: #fcda79;
}

.app-logo {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.mobile-text {
  font-size: 12px;
}

.download-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 5px 10px;
  font-size: 11px;
  border-radius: 10px;
  background-color: #6d69d3;
  -webkit-animation: bounce 0.3s infinite alternate;
  -moz-animation: bounce 0.3s infinite alternate;
  animation: bounce 0.3s infinite alternate;
}

@-webkit-keyframes bounce {
  to {
    -webkit-transform: scale(1.1);
  }
}
@-moz-keyframes bounce {
  to {
    -moz-transform: scale(1.1);
  }
}
@keyframes bounce {
  to {
    transform: scale(1.1);
  }
}

@media (min-width: 768px) {
  .navMenu span {
    display: block;
    font-size: 14px;
  }
  .navMenu img {
    display: none;
  }
  .hide-mobile {
    display: none !important;
  }
  .hide-desktop {
    display: block !important;
  }
  .nav-item {
    margin: 0;
  }
  .logo {
    width: 175px;
  }
  .mobile-banner {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoggedInHeader.vue